module.exports = __webpack_public_path__ + "assets/img/kv-795bd470.jpg";